export default __webpack_public_path__ + "static/left-tree-760b133bdfece44ee171dda5d6f11b29.png";